// extracted by mini-css-extract-plugin
module.exports = {"content":"styles-module--content--RpADO","main":"styles-module--main--1IXJA","information":"styles-module--information--1Q4mh"};